
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/features/[slug]",
      function () {
        return require("private-next-pages/en/features/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/features/[slug]"])
      });
    }
  